<template>
  <div v-loading="true" style="height: 100vh"></div>
</template>

<script setup>
import { payOrderByWx } from "@/api/order";
import { useRouter, useRoute } from "vue-router";
import { setToken, setStore } from "@/utils/auth";
const router = useRouter();
const route = useRoute();

payOrderByWx({ code: route.query.code }).then((res) => { 
  setToken(res.access_token);
  setStore({ name: "unionid", content: res.unionid });
  router.replace({
    path: "/pay",
    query: {
      id: route.query.id
    }
  })
})

</script>